export default __webpack_public_path__ + "static/media/wilson-tour-premier-all-court.048cf767.jpg";